import { render, staticRenderFns } from "./SuccessPublishPresentations.vue?vue&type=template&id=78f7dc36&scoped=true&"
import script from "./SuccessPublishPresentations.vue?vue&type=script&lang=js&"
export * from "./SuccessPublishPresentations.vue?vue&type=script&lang=js&"
import style0 from "./SuccessPublishPresentations.vue?vue&type=style&index=0&id=78f7dc36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f7dc36",
  null
  
)

export default component.exports